export const sanitizeStringForHtmlId = (str: string) =>
  str.replace(/[^a-zA-Z0-9]/g, '-')
